import {Component, ViewChild, Inject, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges} from '@angular/core';
import {MatSnackBar, MatDialog} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';

import {ClickedCoord, MapComponent, MapClickHandler, ClickDisplay} from '../../map.component'

import {FourDService, Transform } from '4d-mapper'
import {MapService} from '../../../../commons/map.service';
import {BaseComponent} from '../../../../commons/BaseComponent';
import { Constants } from '../../../../commons/Constants';

const Cesium = (<any>window).Cesium

@Component({
  selector: 'image-comp',
  templateUrl: './image.component.html',
  // styleUrls: ['../../map_commons.scss','./image.component.scss']
})
export class ImageViewer extends BaseComponent implements OnInit, OnDestroy, MapClickHandler {

  debug:boolean = Constants.debug_off;

  image:Transform
  icon:string

  constructor(route: ActivatedRoute, router: Router, snackBar:
    MatSnackBar, dialog: MatDialog, public mapComp: MapComponent, public mapService: MapService) {

      super(router, snackBar, dialog);

      if ( this.debug ) { console.log ( 'image.comp :: constructor()'); }

      this.addSubscription( 'onPhotosChange',
        mapService.onPhotosChange().subscribe(photos => {

          if ( this.debug ) { console.log ( 'image.comp :: onPhotosChange() --> '); }

          var find = photos.find(f => this.image.id == f.id)
          if(find)
            this.image = find
          else
            delete this.image['selected_position']
        })
      )


      route.params.subscribe(s => {
        if ( this.debug ) { console.log ( 'image.comp :: route.params'); }
      if(s.id){
        this.image = this.mapService.scenePhotos.find(a => a.id == parseInt(s.id))

        if(!this.image){
          this.mapComp.fourD.V.searchByObject(Transform).equals('id',s.id).queryObservable().subscribe(res => {
              if(res.items.length){
                this.image = res.items[0]
                this.mapComp.imageComp.setSelected(this.image)
             //   this.mapService.helper.sendCameraTo(this.image)
              }
              this.loading = false
          },
          e => {
            this.openSnackBarError(e.message)
            this.loading = false
          })
        }
        else{
          this.loading = false
          this.mapComp.imageComp.setSelected(this.image)
         // this.mapService.helper.sendCameraTo(this.image)
        }
      }

      // set the map views tabs to annotations
        // if ( !this.mapComp.viewPhotoBucket ) {
        //   this.mapComp.setTab('image')
        // }
        
      this.mapComp.activeDetails = this
      this.mapComp.detailsNav.open()
    })
  }

  clickedMap(movement: any, rightClick: boolean, checkedPosition):ClickDisplay{
    if ( this.debug ) { console.log ( 'image.comp :: clickedMap()'); }
    if(rightClick){
      this.mapComp.imageComp.setSelected(null)
      return ClickDisplay.Chevron
    }
    else
      // pass actions to map
      return this.mapComp.imageComp.clickedMap(movement,rightClick, checkedPosition)
  }
  showDZI(t: Transform) {
    if ( this.debug ) { console.log ( 'image.comp :: showDZI()'); }
    this.openDZIDialogWith(t, 'TYPES.photo-dzi');
  }
}


/*

NOTE :  image-cell's will pop in and out of memory, as they're created and delete dependant
        on the virtual dynamic area we view the thumbnails through. No need to make this
        component extend BaseComp and have ___event support (unless we really, really need to)
*/
@Component({
  selector: 'image-cell',
  templateUrl: './image-cell.component.html'
})
export class ImageCell implements OnInit, OnChanges {
  @Input()
  image:any = null;
  imageName:string = null;

  @Output()
  onClick = new EventEmitter()

  debug:boolean = Constants.debug_off;

  is360:boolean = false;

  top:any = '0';
  left:any = '0';

  constructor( public mapComp: MapComponent, public mapService: MapService, public fourD:FourDService ) {
    if ( this.debug ) { console.log ( 'image-cell.comp :: constructor()'); }
  }

  ngOnInit() {
    // console.log ( '!!!! imageCell', this.image, this.image['exif_props'] );
    // this.imageName = this.image.ds_name;

    if ( this.image['is360'] ) {
      this.is360 = true;
    }
    this.ngOnChanges();
  }

  ngOnChanges(){
    this.imageName = this.image.ds_name ? this.image.ds_name : this.image.name;
    this.calculateIconPosition();
  }
  onDivClick(){
    if ( this.debug ) { console.log ( 'image-cell.comp :: onDivClick()'); }
    this.onClick.emit();
  }

  calculateIconPosition() {
    if ( this.image && this.image.selected_position ) {
      let top =  ((this.image.selected_position.y / this.image.image.image_height )*100);
      let left = ((this.image.selected_position.x / this.image.image.image_width)*100);
      if ( top > 1 && top < 95 ) {
        this.top = top + '%';
      }
      if ( left > 1 && left < 95 ) {
        this.left = left + '%';
      }
      // console.log('!position!', top, this.top, left, this.left, this.image.selected_position );
    }
  }

  flyToImage(image){
  
    if(/*this.router.url.indexOf('photogram') == -1 &&*/ !this.mapComp.cameraLocked && image.llat && image.llng){
      console.log ( 'image.comp :: flyToImage(image)', image ); 

      var c = image.cartographic();
      c.height = c.height + 300;
      this.mapService.viewer.camera.flyTo({
          destination: Cesium.Cartographic.toCartesian(c),
          duration: 3
      });
      // this.mapService.helper.sendCameraTo(image).subscribe();
    }
  }

  redetect(image:Transform) {

    image.input.dataType = null;
    image.input.saveObservable().subscribe( r => {
      this.fourD.V.api('/api/Dataset/' + image.input.id + '/redetect').subscribe( res => {
        console.log('@@ redetect', image, res, r );
      });
    });
    

  }
  


}
